export default __webpack_public_path__ + "static/media/ripples.64febaac.png";